<template>
  <div class="my-courses-page">
    <h1>Online Tutorials</h1>
    <div class="content">
      <aside class="sidebar">
        <ul>
          <router-link :to="'/my-profile'"><li>My profile</li></router-link>
          <router-link :to="'/my-courses'"
            ><li class="active">Online Tutorials</li></router-link
          >
          <router-link :to="'/live-courses'"><li>Live courses</li></router-link>
          <router-link :to="'/my-requests'"><li>My requests</li></router-link>
        </ul>
      </aside>
      <main class="course-list" v-if="!load || courses.length">
        <CourseCard
          v-for="(course, index) in courses"
          :key="index"
          :image="course.course_image"
          :id="course.id"
          :title="course.name"
          :progress="course.progress || 55"
        />
      </main>
      <main class="course-list-place" v-else>
        <h2>
        You are not registered in any tutorial yet
        </h2>
      </main>
    </div>
    <p class="note">
      <!-- **note for the development: the green progress will be based on completed
      exams -->
    </p>
  </div>
</template>

<script>
import axios from "axios";
import CourseCard from "./CourseCard.vue";
export default {
  components: { CourseCard },
  data() {
    return {
      courses: [
        // {
        //   title: "Blockchain and Crypto Basics",
        //   image: "blockchain-course.png", // Replace with actual image path
        //   progress: 100,
        // },
        // {
        //   title: "Advanced Trading",
        //   image: "blockchain-course.png", // Replace with actual image path
        //   progress: 100,
        // },
      ],
      load: false,
    };
  },
  mounted() {
    this.courseList();
  },
  methods: {
    async courseList() {
      try {
        this.load = false;
        const response = await axios.get("user/course?type=simple");
        this.courses = response.data.data;
        this.load = true;
      } catch (err) {
        this.load = true;
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
/* General Styling */
a {
  color: #fff;
  text-decoration: none;
}
.my-courses-page {
  margin: 0 auto 2rem;
  text-align: left;
  font-family: 'Gothic';
}
.my-courses-page h1 {
  text-align: center;
  padding: 3rem 0;
  font-family: 'GothicB';
  background-color: #0e1332;
  color: #fff;
  font-size: 1.5rem;
}
.content {
  margin-top: 2rem;
  display: flex;
  gap: 2rem;
}

/* Sidebar */
.sidebar {
  flex: 1;
}
.sidebar ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.sidebar ul li {
  padding: 0.75rem 1rem 0.75rem 4rem;
  cursor: pointer;
  font-size: 1rem;
}
.sidebar ul li.active {
  color: orange;
  font-weight: bold;
}

/* Course List */
.course-list {
  flex: 4;
  display: grid;
  font-family: 'GothicB';
  grid-template-columns: repeat(auto-fit, 300px);
  gap: 1rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .content {
    flex-direction: column;
  }

  .sidebar ul {
    text-align: center;
  }

  .sidebar ul li {
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }

  .course-list {
    /* grid-template-columns: 1fr; */
    margin: auto;
  }
}

.note {
  color: red;
  margin: 2rem;
}

.course-list-place {
  flex: 4;
  font-family: 'GothicB';
  display: flex;
  width: 100%;
  background-color: #80808021;
  justify-content: space-around;
  align-items: center;
  min-height: 14rem;
  margin-right: 1rem;
}

@media (max-width: 480px) {
  .my-courses-page h1 {
    font-size: 1.2rem;
    padding: 1rem 0;
  }

  .sidebar ul li {
    font-size: 0.85rem;
    padding: 0.5rem;
  }

  .course-list {
    /* grid-template-columns: 1fr; */
  }
}
</style>
